import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import type { SubmissionManagementPlanKey } from '@ebalance/proto/bffuser/v1/submission_management_model_pb'
import { getNoSubmissionRecordPlan } from '@ebalance/proto/bffuser/v1/submission_management_service-SubmissionManagementService_connectquery'
import type { GetNoSubmissionRecordPlanResponse } from '@ebalance/proto/bffuser/v1/submission_management_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * SubmissionManagementService.GetNoSubmissionRecordPlan を呼ぶ hook (AC-PPD-028)。
 * 業務キーが組めない (URL の query が不正な) 間は取得しない。
 *
 * 取得失敗 (NOT_FOUND を含む) は版の詳細と同じくページ内の取得失敗表示と再読み込みで
 * 扱うため、global QueryClient の `throwOnError: true` を `false` に上書きする
 * (`useGetProcurementPlanDetail` と同じ扱い)。
 */
export function useGetNoSubmissionRecordPlan(
  planKey: SubmissionManagementPlanKey | undefined,
): UseQueryResult<GetNoSubmissionRecordPlanResponse, ConnectError> {
  return useQuery(
    getNoSubmissionRecordPlan,
    { planKey },
    { enabled: planKey !== undefined, throwOnError: false },
  )
}
